module.exports = __webpack_public_path__ + "img/sec3_m.92fd0350.png";